



















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IsOrdinaryPerson } from "@/helper/merchantHelper";
import { PndType } from "@/enums/enums";
import { NewObject } from "@/helper/shareHelper";
import { GetSuggestionPndType } from "@/helper/paymentHelper";

@Component
export default class DropdownPaymentWhtPnd extends Vue {
  @Prop({}) readonly whtPayment!: any;
  @Prop({}) readonly transaction!: any;
  @Prop({}) readonly disabled!: boolean;
  @Prop({}) readonly isNotSuggestionPaymentPnd!: boolean;

  private selectedPnd: any = {
    name: "ภ.ง.ด. 53",
    value: PndType.PND53,
  };

  private options: any = [];

  created() {
    this.CreatePndOption();
  }

  get isOrdinaryPerson() {
    return IsOrdinaryPerson(this.transaction.contact.contactType);
  }

  @Watch("isOrdinaryPerson", { deep: true })
  isOrdinaryPersonChanged() {
    this.CreatePndOption();
  }

  @Watch("whtPayment.pndTypeId", { immediate: true })
  pndTypeIdChanged() {
    const pndType = this.options.find((x: any) => x.value === this.whtPayment.pndTypeId);
    if (pndType) {
      this.selectedPnd = NewObject(pndType);
    }
  }

  @Watch("selectedPnd", { deep: true })
  selectedPndChanged() {
    this.SelectWht(this.selectedPnd);
  }

  @Watch("transaction.contact.id")
  transactionContactIdChanged() {
    this.CreatePndOption();
  }

  @Watch("transaction.transactionItemList", { deep: true })
  transactionItemListChanged() {
    this.CreatePndOption();
  }

  @Watch("whtPayment.whtAmount", { deep: true })
  whtAmountChanged() {
    this.CreatePndOption();
  }

  @Watch("transaction.isNotAuto", { deep: true })
  isNotAutoChanged() {
    this.$emit("update:isNotSuggestionPaymentPnd", this.transaction.isNotAuto);
  }

  public CreatePndOption() {
    this.options = [];
    this.SetPndDropDown();
    if (!this.isNotSuggestionPaymentPnd) {
      this.whtPayment.pndTypeId = null;
      this.$nextTick(() => {
        if (this.whtPayment.whtAmount.ToNumber() > 0) {
          this.whtPayment.pndTypeId = GetSuggestionPndType(this.transaction);
        } else {
          this.whtPayment.pndTypeId = PndType.None;
        }
      });
    } else {
      this.selectedPnd = NewObject(this.options.find((x: any) => x.value === this.whtPayment.pndTypeId));
    }
  }

  public SelectWht(item: any) {
    if (item) {
      this.selectedPnd = item;
      this.whtPayment.pndTypeId = item.value;
    }
  }

  public SetPndDropDown() {
    if (this.whtPayment.whtAmount.ToNumber() > 0) {
      if (this.isOrdinaryPerson) {
        this.options.push({ name: "ภ.ง.ด. 1", value: PndType.PND1kor });
        this.options.push({ name: "ภ.ง.ด. 2", value: PndType.PND2 });
        this.options.push({ name: "ภ.ง.ด. 3", value: PndType.PND3 });
      } else {
        this.options.push({ name: "ภ.ง.ด. 53", value: PndType.PND53 });
      }
    } else {
      this.options.push({ name: "-", value: PndType.None });
    }
  }
}
